import {Component} from "@angular/core";

@Component({
  selector: "common-ngif",
  template: `
  <usecase-container title="NgIf" src="common/ngif">
    <usecase-content>
      <input type="checkbox" (change)="checked=$event.target.checked">
      <span *ngIf="checked">チェックON</span>
      <span *ngIf="!checked">チェックOFF</span>
    </usecase-content>
  </usecase-container>
  `
})
export class NgIfComponent {
}



/** WEBPACK FOOTER **
 ** ./script/common/ngif/component.ts
 **/